import React, {useRef} from 'react';
import './styles.css';
import {appText} from '../../../assets/text/appText';
import {deleteIcon} from '../../../assets/images';

interface Props {
  onChange: (file?: File) => void;
  placeholder: string;
  heading?: string;
  file?: File;
  className?: string;
  isMandatory?: boolean;
  acceptFileTypes?: string;
}

const FilePickerInput = React.memo(
  ({
    onChange,
    placeholder,
    heading,
    file,
    className,
    isMandatory,
    acceptFileTypes,
  }: Props) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        onChange(file);
      }
    };
    const clearFile = () => {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      onChange(undefined);
    };

    return (
      <div className={className}>
        <p className="FilePickerTitle">
          {heading}
          {isMandatory ? <span className="MandatoryIndicator">*</span> : ''}
        </p>
        <div className="FilePickerContainer">
          <div className="FilePickerInput">
            {file ? (
              <>
                <span className="Title">{file.name}</span>
                <button className="ClearButton" onClick={clearFile}>
                  <img src={deleteIcon} alt="delete" />
                </button>
              </>
            ) : (
              <span>{placeholder}</span>
            )}
            <label className="AttachFileButton">
              {appText.browse}
              <input
                ref={fileInputRef}
                type="file"
                onChange={onFileChange}
                accept={acceptFileTypes}
                style={{display: 'none'}}
              />
            </label>
          </div>
        </div>
      </div>
    );
  },
);

export default FilePickerInput;
